import React from 'react';

import i18n from '@nextroll/ar-i18n';
import { Popper, Tooltip, Placements } from '@nextroll/ar-style-base';
import { Link } from '@nextroll/ar-container-app';

import contactEngageIcon from '../../../assets/icons/contact-engage.png';

import { ExpandablePanel } from './ExpandablePanel';


const CONTACT_ENGAGE_LEARN_MORE_LINK = 'https://help.rollworks.com/hc/articles/31625795342221-Contact-Discovery-Workflows-Discover-New-Hot-Contacts';

const EngagedContactsFilterTooltip = () => {
    const tooltipContent = (
        <Tooltip className='workflow-table-total-enrolled-tooltip' placement={Placements.RIGHT}>
            {i18n.gettext(
                'Contacts with at least 1 page view OR 1 ad click over the past 30 days. <LINK>Learn more</LINK>',
                { LINK: <Link to={CONTACT_ENGAGE_LEARN_MORE_LINK} openNewWindow rel='noopener noreferrer' /> }
            )}
        </Tooltip>
    );

    return (
        <Popper hoverContent={tooltipContent} breakOutOfOverflow>
            <i aria-label='engaged-contacts-filter-tooltip' className='far fa-info-circle engaged-contacts-filter' />
        </Popper>
    );
};

export const ExpandablePanelContactEngageFilter = ({ filters, setFilters }: {
    filters: string[];
    setFilters: (filters: string[]) => void;
}) => {
    return (
        <ExpandablePanel
            title={i18n.gettext('Contact Engagement')}
            icon={<img src={contactEngageIcon} alt='icon' height={16} width={16} style={{ marginRight: -2 }} />}
            items={filters}
            setItems={setFilters}
            className={{ body: 'workflow-node-panel-filter-contact-engage' }}
        >
            <span key='filter-contact-engagement-checkbox'>
                <input
                    type='checkbox'
                    id='filter-contact-engagement-checkbox'
                    name='filter-contact-engagement'
                    checked={filters.length > 0}
                    onChange={e => setFilters(e.target.checked ? ['activityQuery'] : [])}
                    className='ar-checkbox'
                />
                <label htmlFor='filter-contact-engagement-checkbox'>
                    {i18n.gettext('Has visited website OR clicked on an ad')}
                    <EngagedContactsFilterTooltip />
                </label>
            </span>
        </ExpandablePanel>
    );
};
